// src/components/super-admin/SuperAdminLayout.js - Super Admin 전용 레이아웃

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminSidebar from './SuperAdminSidebar';
import { useAppContext } from '../../context/AppContext';
import './SuperAdminLayout.scss';

const SuperAdminLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { user, sessionChecked } = useAppContext();
  const navigate = useNavigate();

  // 세션 확인 전: 로딩
  if (!sessionChecked) {
    return (
      <div className="sa-layout">
        <div className="sa-content">
          <div className="sa-body">
            <div className="sa-loading">로딩 중...</div>
          </div>
        </div>
      </div>
    );
  }

  // Super Admin이 아니면 접근 차단
  if (!user || user.tier !== 'super') {
    return (
      <div className="sa-layout">
        <div className="sa-content">
          <div className="sa-body">
            <div style={{ maxWidth: 480, margin: '80px auto', textAlign: 'center' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px', color: '#111827' }}>
                접근 권한이 없습니다
              </h2>
              <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px' }}>
                이 페이지는 최고 관리자(Super Admin)만 접근할 수 있습니다.
              </p>
              <button
                type="button"
                onClick={() => navigate('/workspace')}
                style={{
                  padding: '8px 16px',
                  borderRadius: '999px',
                  border: 'none',
                  backgroundColor: '#111827',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                워크스페이스로 돌아가기
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sa-layout">
      <SuperAdminSidebar isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} />
      <div className="sa-content">
        <div className="sa-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLayout;